var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.direction,attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18.122","height":"34.393","viewBox":"0 0 35 35"}},[_c('path',{attrs:{"data-name":"Path 486","d":"M.729.707l16 16-16 17","fill":"none","stroke-width":"4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }